import { Button } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

const PrimaryLinkButton = ({
  label,
  to,
  variant = "contained",
  type = null,
  disabled,
  id = null,
}) => {
  return (
    <Button
      variant={variant}
      id={id}
      color="primary"
      sx={{ width: "100%" }}
      to={to}
      LinkComponent={Link}
      type={type}
      disabled={disabled}
    >
      {label}
    </Button>
  );
};

export default PrimaryLinkButton;
